import { Box, Typography } from '@mui/material';
import _ from 'lodash';

import { useEffect, useState } from 'react';
import { getDpdBuckets, getProgramDelinquency } from '../../../api/collections';
import { GREY } from '../../../constants/style';
import { useProgramData } from '../../../providers/ProgramDataProvider';
import { useSnackbar } from '../../../providers/SnackbarProvider';
import { DelinquencyReport } from '../../../types/collection';
import { getErrorMessageFromErrorObj } from '../../../utils/api';
import { FileUtils } from '../../../utils/file';
import { VegaCard, VegaTable } from '../../common';

import VegaOutlineButton from '../../common/VegaOutlineButton';
import VegaText from '../../common/VegaText';
import DPDbucketSelector from './DPDbucketSelector';

type DpdType = {
  dpd: string;
};

export const getSelected = (value: string, arr: any[]) => {
  return arr.some((item: any) => value === item);
};

type Props = {};

const LeadsByDPDbucket = ({}: Props) => {
  const { selectedProgram } = useProgramData();
  const { setSnackbar } = useSnackbar();
  const [deliquencyData, setDeliquencyData] = useState<DelinquencyReport[]>([]);
  const [filteredDeliquencyData, setFilteredDeliquencyData] = useState<
    DelinquencyReport[]
  >([]);
  const [dpdBuckets, setDpdBuckets] = useState<DpdType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectDPDbucket, setSelectDPDbucket] = useState<string[]>([]);

  const columnDef = [
    {
      field: 'customer_id',
      headerName: <Typography variant="body2">Customer ID</Typography>,
      flex: 0.7,
    },
    // {
    //   field: 'customerInfo',
    //   headerName: <Typography variant="body2">Customer Info</Typography>,
    //   flex: 1,
    //   renderCell: (props: any) => {
    //     return <VegaOutlineButton text={'View'} isPrimary />;
    //   },
    // },
    {
      field: 'outstanding_amount',
      headerName: <Typography variant="body2">O/B Balance</Typography>,
      flex: 0.7,
    },
    {
      field: 'total_overdue_amount',
      headerName: <Typography variant="body2">O/D Balance</Typography>,
      flex: 0.7,
    },
    {
      field: 'delinquency_level',
      headerName: <Typography variant="body2">DPD Bucket</Typography>,
      flex: 0.7,
      renderCell: (props: any) => {
        const bucket = props.row.delinquency_level;
        return <Typography>{_.startCase(_.toLower(bucket))}</Typography>;
      },
    },
    {
      field: 'delinquency_days',
      headerName: <Typography variant="body2">DPD</Typography>,
      flex: 0.5,
    },
    {
      field: 'risk_profile',
      headerName: <Typography variant="body2">Risk</Typography>,
      flex: 0.5,
    },
    {
      field: 'agent_name',
      headerName: <Typography variant="body2">Agent</Typography>,
      flex: 1,
    },
  ];

  const onSelectDPDbucket = (value: any, index: number) => {
    const isSelected = getSelected(value, selectDPDbucket);

    if (!isSelected) {
      setSelectDPDbucket([...selectDPDbucket, value]);
    } else {
      const filterDPDbucket = selectDPDbucket.filter(
        (item: any) => item !== value
      );

      setSelectDPDbucket(filterDPDbucket);
    }
  };

  function fetchDeliquencyReports() {
    setDeliquencyData([]);
    setFilteredDeliquencyData([]);
    setDpdBuckets([]);
    const programId = selectedProgram?.programId;
    if (!programId) return;
    setLoading(true);
    getProgramDelinquency({ programId })
      .then((res) => {
        setDeliquencyData(res);
        setFilteredDeliquencyData(res);
        fetchDpdBuckets();
      })
      .catch((err) => {})
      .finally(() => {
        setLoading(false);
      });
  }

  function fetchDpdBuckets() {
    setLoading(true);
    getDpdBuckets()
      .then((res) => {
        const buckets = res.map((item) => {
          const bucket: DpdType = {
            dpd: item,
          };
          return bucket;
        });
        setDpdBuckets(buckets);
      })
      .catch((err) => {})
      .finally(() => setLoading(false));
  }

  function filterDeliquencyData() {
    if (selectDPDbucket.length <= 0) {
      setFilteredDeliquencyData(deliquencyData);
      return;
    }
    const filteredData = deliquencyData.filter((item) => {
      const includes = selectDPDbucket.includes(item.delinquency_level);
      return includes;
    });
    setFilteredDeliquencyData(filteredData);
  }

  function onDownloadClick() {
    FileUtils.downloadJsonFile({
      data: filteredDeliquencyData,
      fileName: 'deliquency_data',
    });
  }

  useEffect(() => {
    fetchDeliquencyReports();
  }, [selectedProgram]);

  useEffect(() => {
    filterDeliquencyData();
  }, [selectDPDbucket]);

  return (
    <VegaCard fullHeight noPad>
      <Box
        sx={{
          px: 3,
          py: 2,
          bgcolor: GREY.light,
          borderTopLeftRadius: '20px',
          borderTopRightRadius: '20px',
        }}
      >
        <VegaText text="Collection Leads by DPD buckets" />
      </Box>

      <Box sx={{ p: 3 }}>
        <DPDbucketSelector
          data={dpdBuckets}
          onSelect={onSelectDPDbucket}
          state={selectDPDbucket}
          onDownloadClick={onDownloadClick}
          disableDownloadButton={filteredDeliquencyData.length <= 0}
        />
      </Box>
      <Box sx={{ p: 3 }}>
        <VegaTable
          border
          loading={loading}
          data={filteredDeliquencyData}
          columnDef={columnDef}
          idColumn={'id'}
        />
      </Box>
    </VegaCard>
  );
};

export default LeadsByDPDbucket;
